import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/component/layout/layout.component';
import { AccessdeniedComponent } from './shared/components/accessdenied/accessdenied.component';
import { NotfoundComponent } from './shared/components/notfound/notfound.component';
import { authGuard, noAuthGuard, roleGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: '',
        canActivate: [noAuthGuard],
        loadChildren: () => import('./auth/auth.routes')
    },
    {
        path: 'sp',
        component: LayoutComponent,
        children: [
            {
                path: '',
                canActivate: [roleGuard],
                data: { roles: ['ROOT', 'ADMIN', 'RRHH', 'ASISTENTERRHH', 'CONTADOR', 'ASISTENTECONTADOR', 'ECOMMERCE', 'ASISTENTEECOMMERCE', 'CLIENTE'] },
                loadChildren: () => import('./modules/avancemos/avancemos.routes')
            }
        ]
    },
    {
        path: 'auth',
        canActivate: [noAuthGuard],
        loadChildren: () => import('./auth/auth.routes')
    },
    { path: 'notfound', component: NotfoundComponent },
    { path: 'denied', component: AccessdeniedComponent },
    { path: '**', redirectTo: '/notfound' }
];
